export enum WorkflowPrioritization {
  FastCycle = 1,
  EvolvingInsights = 4,
  FirstTake = 5
}
